import React from "react";
import { FaChevronDown, FaGlobeAmericas } from "react-icons/fa";
import "./styles/CountrySelect.css";

class CountrySelect extends React.Component {
  state = {
    open: false,
  };

  wrapperRef = React.createRef();

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  handleClickOutside = (event) => {
    if (
      this.wrapperRef.current &&
      !this.wrapperRef.current.contains(event.target)
    ) {
      this.setState({ open: false });
    }
  };

  getSelectedCountry = () => {
    const { countries, value } = this.props;
    return (countries || []).find(
      (item) => String(item.prefix) === String(value)
    );
  };

  toggleMenu = () => {
    this.setState((prev) => ({ open: !prev.open }));
  };

  selectCountry = (item) => {
    const { name, onChange } = this.props;
    if (onChange) {
      onChange({
        target: {
          name,
          value: item.prefix,
        },
      });
    }
    this.setState({ open: false });
  };

  render() {
    const {
      id,
      placeholder,
      hasError,
      countries = [],
      value,
    } = this.props;
    const { open } = this.state;
    const selected = this.getSelectedCountry();

    return (
      <div
        ref={this.wrapperRef}
        className={`country-select${hasError ? " country-select--invalid" : ""}${
          open ? " country-select--open" : ""
        }`}
      >
        <button
          type="button"
          id={id}
          className="country-select__trigger"
          onClick={this.toggleMenu}
          aria-haspopup="listbox"
          aria-expanded={open}
        >
          {selected?.flag ? (
            <img
              src={selected.flag}
              alt=""
              className="country-select__flag"
            />
          ) : (
            <span className="country-select__icon" aria-hidden="true">
              <FaGlobeAmericas />
            </span>
          )}
          <span
            className={`country-select__label${
              selected ? "" : " country-select__label--placeholder"
            }`}
          >
            {selected
              ? `${selected.name} (+${selected.lada})`
              : placeholder}
          </span>
          <FaChevronDown className="country-select__chevron" aria-hidden="true" />
        </button>

        {open && (
          <ul className="country-select__menu" role="listbox">
            {countries.map((item) => {
              const isSelected = String(item.prefix) === String(value);
              return (
                <li
                  key={item.prefix}
                  role="option"
                  aria-selected={isSelected}
                  className={`country-select__option${
                    isSelected ? " is-selected" : ""
                  }`}
                  onClick={() => this.selectCountry(item)}
                >
                  {item.flag ? (
                    <img
                      src={item.flag}
                      alt=""
                      className="country-select__flag"
                    />
                  ) : (
                    <span className="country-select__flag country-select__flag--placeholder" />
                  )}
                  <span className="country-select__option-text">
                    {item.name} (+{item.lada})
                  </span>
                </li>
              );
            })}
          </ul>
        )}
      </div>
    );
  }
}

export default CountrySelect;
